import { render } from "./ProgramTrackEditItemPane.vue?vue&type=template&id=d81da12a&scoped=true&ts=true"
import script from "./ProgramTrackEditItemPane.vue?vue&type=script&lang=ts"
export * from "./ProgramTrackEditItemPane.vue?vue&type=script&lang=ts"

import "./ProgramTrackEditItemPane.vue?vue&type=style&index=0&id=d81da12a&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d81da12a"]])

export default __exports__